import React, { Component } from "react";

import Dialog from "components/general/Dialog";
import EmbedPrompt from "components/player_internal/EmbedPrompt";
import Player from "components/player/Player";
import { withRouter } from "react-router";

export class PlayerInternal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEmbedModalVisible: false,
      embedJobClipTrackPermalink: null,
    };
  }

  handleGetEmbedLinkClick = (jobClipTrackPermalink = null) => {
    this.setState({
      isEmbedModalVisible: true,
      embedJobClipTrackPermalink: jobClipTrackPermalink,
    });
  };

  handleEmbedModalCloseClick = () => {
    this.setState({
      isEmbedModalVisible: false,
      embedJobClipTrackPermalink: null,
    });
  };

  render() {
    const { isEmbedModalVisible, embedJobClipTrackPermalink } = this.state;
    const {
      forwardRef,
      jobClip,
      shouldOpenEmbedCodeInNewTab,
      shouldHidePuckBranding,
      onFocus,
      ...rest
    } = this.props;

    return (
      <div>
        <Dialog
          isLarge
          isVisible={isEmbedModalVisible}
          onCloseClick={this.handleEmbedModalCloseClick}
        >
          <EmbedPrompt
            jobClip={jobClip}
            jobClipTrackPermalink={embedJobClipTrackPermalink}
          />
        </Dialog>
        <Player
          onFocus={onFocus}
          ref={forwardRef}
          jobClip={jobClip}
          {...rest}
          onGetEmbedLinkClick={
            !shouldOpenEmbedCodeInNewTab && this.handleGetEmbedLinkClick
          }
          shouldHidePuckBranding={shouldHidePuckBranding}
        />
      </div>
    );
  }
}

export default withRouter(PlayerInternal);
